__turbopack_context__.v({
  "buttonClass": "e7WGRa_buttonClass",
  "learn-more": "e7WGRa_learn-more",
  "newOne": "e7WGRa_newOne",
  "newsLettetPb": "e7WGRa_newsLettetPb",
  "plusFont": "e7WGRa_plusFont",
  "promoButton": "e7WGRa_promoButton",
  "smallButton": "e7WGRa_smallButton",
  "sub-button": "e7WGRa_sub-button",
  "submit-button": "e7WGRa_submit-button",
  "unsubscribe-btn": "e7WGRa_unsubscribe-btn",
});
